export default __webpack_public_path__ + "static/media/dep2_3.9b355d58.png";